import React from 'react';
import { string } from 'prop-types';

const ParksIcon = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <title>park-icon</title>
      <g fill="none">
        <g>
          <g transform="translate(-70 -130) translate(70 130)">
            <circle cx="20" cy="20" r="20" fill="#F2F2F2" />
            <g fill="#428A13">
              <path
                d="M11 21h2v-3c0-.552.447-1 1-1h5.826l-4.585-5.349c-.255-.297-.312-.714-.15-1.069.164-.354.518-.582.909-.582h2.586L12 3.414 5.414 10H8c.39 0 .745.228.908.582.163.355.106.772-.15 1.069L4.175 17H10c.553 0 1 .448 1 1v3zm3 2h-4c-.553 0-1-.448-1-1v-3H2c-.391 0-.745-.228-.908-.582-.163-.355-.106-.772.149-1.069L5.826 12H3c-.404 0-.77-.244-.924-.617-.155-.374-.07-.804.217-1.09l9-9c.39-.391 1.023-.391 1.414 0l9 9c.286.286.372.716.217 1.09-.154.373-.52.617-.924.617h-2.826l4.585 5.349c.255.297.312.714.149 1.069-.163.354-.517.582-.908.582h-7v3c0 .552-.447 1-1 1z"
                transform="translate(8 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

ParksIcon.propTypes = {
  className: string
};

ParksIcon.defaultProps = {
  className: ''
};

export default ParksIcon;
